import * as React from 'react';
import { Col, Row } from 'antd';
import { observer } from 'mobx-react';
import { Prompt } from 'react-router';

import { TextView } from 'src/core/ui/text.view';
import { TabLanguageController } from 'src/core/ui/language/tab-language.controller';
import { CardController } from 'src/app/shared/card.controller';
import { HeaderView } from 'src/app/shared/header.view';

interface CurrencyFormViewProps extends ComponentViewProps<CurrencyItem> {
	title: string,
	save: () => void,
	cancel: () => void,
	model: CurrencyItem;
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	setBusy(isBusy: boolean);
	contextService: any;
}

@observer
export class CurrencyFormView extends React.Component<CurrencyFormViewProps, any> {
	constructor(props: any) {
		super(props);
	}

	render() {
		const model = this.props.model;
		if (model == null) {
			return null;
		}

		const mode = this.props.mode;
		const displayNames = model.dynamicProperties['displayName'];
		const array: TabLanguageModel[] = [{ title: 'Title', dynamicProperties: displayNames, required: true }];

		return (
			<div className="window window-normal">
				<Prompt
					when={this.props.contextService.isDirty}
					message={location => `If you go to ${location.pathname}, all changes will be lost. Are you sure you want to continue?`}
				/>
				<Row>
					<Col xs={24} lg={{ offset: 6, span: 12 }}>
						<Row>
							<Col xs={24}>
								<HeaderView
									title={this.props.title}
									mode={this.props.mode}
									onModeChanged={this.props.onModeChanged}
									save={this.props.save}
									cancel={this.props.cancel}
									contextService={this.props.contextService}
								/>
							</Col>
						</Row>
						<CardController
							mode={this.props.mode}
							icon="book"
							title="General information">
							<Row>
								<Col xs={24}>
									<TabLanguageController
										dynamicProperties={array}
										model={this.props.model}
										mode={mode}
										setBusy={this.props.setBusy}
										isRichTextBox={false}
									/>
								</Col>
								<Col xs={24}>
									<TextView required
										onGetErrorMessage={() => this.props.model.validate(false, 'iso3Name')}
										mode={mode}
										label="ISO"
										value={model.iso3Name}
										onChanged={newVal => model.iso3Name = newVal}
									/>
								</Col>
								<Col xs={24}>
									<TextView
										onGetErrorMessage={() => this.props.model.validate(false, 'centsCurrency')}
										mode={mode}
										label="Cents Currency"
										value={model.centsCurrency}
										onChanged={newVal => model.centsCurrency = newVal}
									/>
								</Col>
								<Col xs={24}>
									<TextView
										required
										onGetErrorMessage={() => this.props.model.validate(false, 'symbol')}
										mode={mode}
										label="symbol"
										value={model.symbol}
										onChanged={newVal => model.symbol = newVal}
									/>
								</Col>
								<Col xs={24}>
									<TextView
										required
										onGetErrorMessage={() => this.props.model.validate(false, 'decimalPlaces')}
										mode={mode}
										label="Decimal Places"
										value={model.decimalPlaces}
										onChanged={newVal => model.decimalPlaces = newVal}
									/>
								</Col>
								<Col xs={24}>
									<TextView required
										onGetErrorMessage={() => this.props.model.validate(false, 'format')}
										mode={mode}
										label="Format"
										value={model.format}
										onChanged={newVal => model.format = newVal}
									/>
								</Col>
							</Row>
						</CardController>
					</Col>
				</Row>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/currencies/form/currency-form.view.tsx